<template>
    <div id="boby" v-show="!this.$store.state.loading">
        <div class="header">
            <div class="header-left">
                <div class="product">
                    <span  class="item-title">商品 :</span>
                    <span class="item">[{{ productId }}] {{ productName }}</span>
                </div>
                <div class="calendar">
                    <Datepicker class="datepicker" format="yyyy-MM-dd" v-model="startday" :disabled-dates="disabledDates" :language="ja" placeholder="開始日"/>
                    <span>〜</span>
                    <Datepicker class="datepicker" format="yyyy-MM-dd" v-model="endday" :disabled-dates="disabledDates" :language="ja" placeholder="終了日"/>
                </div>
                <div class="pr_media">
                    <span class="media">PR媒体 :</span>
                    <v-select :options="mediaOptions" v-model="selectedMedium"></v-select>
                </div>
            </div>
            <div class="header-right">
                <a class="btn closeBtn" @click="$emit('modalClosed')">×</a>
            </div>
        </div>
        <div class="content">
            <div v-if="Object.keys(costs).length !== 0" class="content-item">
                <ul v-for="(outputdays, month) in costs" :key="month" class="months">
                    <p class="month">{{month}}</p>
                    <li v-for="(cost, outputday) in outputdays" :key="outputday" class="cost">
                        <span class='outputday'>{{outputday}}</span>
                        <input v-model="costs[month][outputday]" class="cost-input" type="text">
                    </li>
                </ul>
            </div>
            <div v-else class="message">
                <span>期間とPR媒体を選択して下さい。</span>
            </div>
        </div>
        <div class="footer">
            <p class="btn update-button" @click="updateCosts()">更新</p>
            <p class="error-message">{{errorMessage}}</p>
        </div>
    </div>
</template>

<script>
import {ja} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'

export default {
    name: 'InputPrCost',
    components: {
        Datepicker
    },
    data() {
        return {
            startday: null,
            endday: null,
            disabledDates: {
                from: null,
                to: new Date('2021-12-01')
            },
            ja: ja,
            errorMessage: '',
            mediaOptions: [],
            selectedMedium: {},
            costs: {}
        }
    },
    props: {
        productId: Number,
        productName: String
    },
    created: function() {
        this.$store.dispatch("loading", true);
        this.axios.get("/api/prMedia?productId=")
        .then((res) => {
            Object.keys(res.data).forEach((mediumId) => {
                this.mediaOptions.push({label: res.data[mediumId], id: mediumId})
            })
        })
        this.$store.dispatch("loading", false);
    },
    methods: {
        updateCosts() {
            // 期間・PR媒体を選択していない場合はthis.costsが空オブジェクト。 return。
            if(Object.keys(this.costs).length === 0) {
                return;
            }
            // TODO: バリデーションと空文字削除まとめたい
            // 半角数字バリデーション
            this.errorMessage = '';
            Object.keys(this.costs).forEach((month) => {
                Object.keys(this.costs[month]).some((outputday) => {
                    if (this.costs[month][outputday].match(/^[0-9]*$/) === null) {
                        this.errorMessage = '※ 半角数字を入力して下さい。';
                    }
                })
            })
            if (this.errorMessage !== '') {
                return;
            }
            this.$store.dispatch("loading", true);
            // 空欄は削除。DBのレコードを増やさないため。
            // '0'はそのまま'0'。'0'へ変更もあり得るため。
            Object.keys(this.costs).forEach((month) => {
                Object.keys(this.costs[month]).some((outputday) => {
                    if (this.costs[month][outputday] === '') {
                        this.$delete(this.costs[month], outputday);
                    }
                })
            })
            this.axios.put("/api/pr?productId="+this.productId, {costs: this.costs, mediumId: this.selectedMedium.id})
            .then(() => {
                this.$store.dispatch("loading", false);
                this.$emit('modalClosed');
            }).catch(() => {
                //
            })
        },
        reverseDays() {
            if ((this.startday !== null && this.endday !== null) &&
            (this.startday > this.endday)) {
                [this.startday, this.endday] = [this.endday, this.startday];
            }
        },
        getCosts() {
            if (Object.keys(this.selectedMedium).length === 0 || this.startday === null || this.endday === null) {
                return;
            }
            this.$store.dispatch("loading", true);
            const start = this.$dayjs(this.startday).format('YYYY-MM-DD');
            const end = this.$dayjs(this.endday).format('YYYY-MM-DD');
            this.costs = {};
            this.axios.get(`/api/prCosts?productId=${this.productId}&mediumId=${this.selectedMedium.id}&startday=${start}&endday=${end}`)
            .then((res) => {
                Object.keys(res.data).forEach((month) => {
                    this.$set(this.costs, month, res.data[month]);
                    Object.keys(res.data[month]).forEach((outputday) => {
                        this.$set(this.costs[month], outputday, String(res.data[month][outputday]));
                    })
                })
                // 欠落した日付を補完。値は ''
                let dates = {};
                for (let date = new Date(this.startday); date <= this.endday; date.setDate(date.getDate() + 1)) {
                    let costMonth = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2);
                    if (!(costMonth in dates)) {
                        this.$set(dates, costMonth, []);
                    }
                    dates[costMonth].push(
                        costMonth + '-' + ('0' + date.getDate()).slice(-2)
                    );
                }
                Object.keys(dates).forEach((month) => {
                    if (!(month in this.costs)) {
                        this.$set(this.costs, month, {});
                    }
                    dates[month].forEach((day) => {
                        if (!(day in this.costs[month]) || this.costs[month][day] === '0') {
                            this.$set(this.costs[month], day, '');
                        }
                    })
                })
                // 月で昇順
                this.costs = this.sortDays(this.costs);
                // 日付で昇順
                Object.keys(this.costs).forEach((month) => {
                    this.costs[month] = this.sortDays(this.costs[month])
                })
                this.$store.dispatch("loading", false);
            }).catch(() => {
                //
            })
        },
        sortDays(sorts) {
            let temp = Object.entries(sorts);
            temp.sort(function(a, b) {
                if (a[0] < b[0]) { return -1; }
                if (a[0] > b[0]) { return 1; }
                return 0;
            })
            return Object.fromEntries(temp);
        }
    },
    watch: {
        startday: function() {
            this.reverseDays();
            this.getCosts();
        },
        endday: function () {
            this.reverseDays();
            this.getCosts();
        },
        selectedMedium: function() {
            this.getCosts();
        }
    }
}
</script>

<style scoped lang="sass">
#boby
    margin: 30px
    color: $grayColor
    font-size: 1.6rem
    .header
        display: flex
        justify-content: space-between
        .header-left
            display: flex
            align-items: center
            .calendar
                display: flex
                justify-content: flex-start
                align-items: center
                margin-right: 40px
            .product
                display: flex
                align-items: center
                .item-title
                    margin-right: 10px
                .item
                    font-weight: bold
                    margin-right: 40px
            .pr_media
                display: flex
                align-items: center
                .media
                    margin-right: 10px
        .header-right
            .btn.closeBtn
    .content
        margin: 10px 0 16px 0
        padding: 10px
        height: 760px
        border: solid 1px $mainColor
        overflow: scroll
        .content-item
            display: flex
            .months
                margin: 0 30px
                .month
                    font-weight: bold
                    margin-bottom: 8px
                .cost
                    display: flex
                    justify-content: center
                    align-items: center
                    margin-bottom: 3px
                    .outputday
                        margin-right: 20px
                        width: 100px
                    .cost-input
        .message
            height: 100%
            width: 100%
            display: flex
            justify-content: center
            align-items: center
    .footer
        display: flex
        justify-content: flex-start
        .update-button
            padding: 10px 0
            margin-left: 45%
            width: 10%
        .error-message
            margin-left: 20px
            color: rgba(255, 0, 0, 1)
</style>
